import { ResourcesConfig } from 'aws-amplify';

const amplifyConfig: ResourcesConfig = {
  API: {
    GraphQL: {
      endpoint: process.env.REACT_APP_GraphQLEndpoint ?? '',
      region: process.env.REACT_APP_AwsRegion,
      defaultAuthMode: 'iam',
      // apiKey: process.env.REACT_APP_ApiKey
    }
  },
  Storage: {
    S3: {
      bucket: process.env.REACT_APP_NameListUploadBucket,
      region: process.env.REACT_APP_AwsRegion
    }
  },
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_UserPoolId ?? '',
      userPoolClientId: process.env.REACT_APP_UserPoolWebClientId ?? '',
      identityPoolId: process.env.REACT_APP_IdentityPoolId ?? '',
      allowGuestAccess: true,
      signUpVerificationMethod: 'code'
    }
  }
};

export default amplifyConfig;
